import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scan-product light-light-background p-4" }
const _hoisted_2 = {
  class: "highlight-box w-mc px-2 fs-smaller fw-600 light-light-color highlight-bg-coral card-border",
  style: {"padding-top":"2px","padding-bottom":"2px"}
}

import {
    IonRow,
    IonCol,
    IonText, modalController
} from "@ionic/vue";
import { computed } from "vue";

import InputAmount from "@/components/input/InputAmount.vue";

import { useUserStore } from "@/stores/user";
import { useListStore } from "@/stores/lists";

import { convertNumberWithComma } from "@/functions/converter";

import { CatalogItem } from "@/types/supplier";
import { PERMISSION_KEY } from "@/types/user";
import ButtonBase from "@/components/button/ButtonBase.vue";

interface ScanProductProps {
    catalogItem: CatalogItem;
    supplierId: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ScanProduct',
  props: {
    catalogItem: {},
    supplierId: {}
  },
  setup(__props: any) {

const props = __props

const { permission } = useUserStore()
const { changeItemQuantity } = useListStore()

const amount = computed<number>({
    get: () => {
        return props.catalogItem.quantity ?? 0
    },
    set: (value) => {
        changeItemQuantity(props.supplierId, props.catalogItem.id, value)
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonRow), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCol), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonText), {
              class: "octo-gradient-purple-color fs-18 fw-b",
              style: {"line-height":"24px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.catalogItem.name), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (__props.catalogItem.itemNumber)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 0,
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "fs-smaller grey1-grey1-color" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('label.articleNo')) + ": " + _toDisplayString(__props.catalogItem.itemNumber), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (__props.catalogItem.price)
              ? (_openBlock(), _createBlock(_unref(IonCol), {
                  key: 0,
                  class: "fw-b fs-larger",
                  size: "auto"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(convertNumberWithComma)(__props.catalogItem.price.toFixed(3))) + " € ", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.catalogItem.packaging)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 1,
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "center-y" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(__props.catalogItem.packaging), 1)
              ]),
              _: 1
            }),
            (__props.catalogItem.price)
              ? (_openBlock(), _createBlock(_unref(IonCol), {
                  key: 0,
                  class: "fw-b fs-larger",
                  size: "auto"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(convertNumberWithComma)(__props.catalogItem.price.toFixed(3))) + " € ", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(permission)[_unref(PERMISSION_KEY).LIST_ITEM_UPDATE] && __props.catalogItem.targetStock)
      ? (_openBlock(), _createBlock(_unref(IonRow), {
          key: 2,
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), {
              size: "4",
              class: "fs-smaller"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('label.targetStock')) + ": ", 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(IonCol), { size: "8" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.catalogItem.targetStock), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(IonRow), { class: "center mt-2" }, {
      default: _withCtx(() => [
        (_unref(permission)[_unref(PERMISSION_KEY).LIST_ITEM_UPDATE])
          ? (_openBlock(), _createBlock(_unref(IonCol), {
              key: 0,
              size: "8"
            }, {
              default: _withCtx(() => [
                _createVNode(InputAmount, {
                  modelValue: amount.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((amount).value = $event)),
                  small: "",
                  "amount-step": __props.catalogItem.amountStep,
                  "min-value": 1
                }, null, 8, ["modelValue", "amount-step"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_unref(IonRow), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonCol), {
          offset: "2",
          size: "8"
        }, {
          default: _withCtx(() => [
            _createVNode(ButtonBase, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(modalController).dismiss())),
              class: "max-width"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('button.add')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})